import React from 'react';

// See https://github.com/welldone-software/why-did-you-render#options

if (process.env.NODE_ENV === 'development') {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-console -- Show information that `whyDidYouRender` has been applied to the website.
    console.debug(
      'Applying whyDidYouRender, to help you locate unnecessary re-renders during development. See https://github.com/welldone-software/why-did-you-render'
    );

    const whyDidYouRender = require('@welldone-software/why-did-you-render');
    whyDidYouRender(React, {
      trackAllPureComponents: false,
      trackHooks: false,
      logOwnerReasons: false,
      collapseGroups: true,
      // This is for testing, remove it, if you don't want to log on different values
      logOnDifferentValues: false,
    });
  }
}
